const seeOngoingResearchesPermissions = ['ongoing_researches:admins', 'ongoing_researches:viewers'];

const createOngoingResearchesPermissions = ['ongoing_researches:admins', 'ongoing_researches:coordinators'];

const anyOngoingResearchesPermissions = [...seeOngoingResearchesPermissions, ...createOngoingResearchesPermissions];

export { anyOngoingResearchesPermissions, createOngoingResearchesPermissions, seeOngoingResearchesPermissions };
